// extracted by mini-css-extract-plugin
module.exports = {"offer":"offer--3X0kY","boxTitle":"boxTitle--21UEa","info":"info--2et8U","high":"high--3f9gV","btns":"btns--2jMdC","yellowBtn":"yellowBtn--1u3bY","editor":"editor--3TAo6"};